/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
 window.currentVariant_id = jQuery(form).serialize().split('id=')[1].split('&')[0];
 qntity = jQuery(form).serialize().split('quantity=')[1];
 //console.log("qntity>>>>", qntity);
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      let data = line_item;
      data.quantity  = parseInt(qntity);
      onproductAdded(data); // call the customEvent
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
       ShopifyAPI.onItemAdded(line_item, form);
       
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $buyItNowBtn, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, addItemToCart;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : '.enj-add-to-cart-btn',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true,
      buyItNowBtn: '.shopify-payment-button [data-btn-buynow]'
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $buyItNowBtn = $formContainer.find(settings.buyItNowBtn);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
	  $('.product-popup').find('.product-item-count').html(cart.item_count);  
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
        $('.js-number-cart').removeClass('active');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  var toggleMiniCart = function(show) {
    if(show) $(".js-minicart").addClass("active");
    else $(".js-minicart").removeClass("active");
  }

  addItemToCart = async function(form) {
    try {
      const formData = new FormData(form);
      formData.append('sections', 'minicart');
      formData.append('sections_url', window.location.pathname);

      const data = {
        "items": [{
          "id": formData.get('id'),
          "quantity": formData.get('quantity')
        }],
        "sections": "minicart",
        "sections_url": window.location.pathname
      };

      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(data)
      });

      const result = await resp.json();

      if(result.status === 422) throw Error(result.message);

      _theme.Helpers.cartAddedCallBack(result);
      form.querySelector(settings.addToCartSelector).classList.remove('is-adding');
      toggleMiniCart(true);
    } catch (error) {
      form.querySelector(settings.addToCartSelector).classList.remove('is-adding');
      _theme.Helpers.showToastNotification(error.message);
      //console.log('error', error);
    }
  }

  formOverride = function () {
    $formContainer.on('submit', async function(evt) {
      evt.preventDefault();
      var productHandle = $(this).data('product-handle');
      var $addToCart_btn = $(this).find(settings.addToCartSelector);
      // Add class to be styled if desired
      $addToCart_btn.removeClass('is-added').addClass('is-adding');
      $addToCart_btn.find("i").replaceWith('<i class="enj-loader-add-to-cart fsz-unset"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>');

      // Remove any previous quantity errors
      $('.qty-error:not(.limited-stock)').remove();
      if($('.qty-error.limited-stock'))$('.qty-error.limited-stock').show();

      var formData = new FormData(this);
      const vid = formData.get('id');
      var qntty = formData.get('quantity');
      var quantityReg = new RegExp('^[0-9]+$');
      
      if (!quantityReg.test(qntty) || qntty == 0) {
        console.log("qnttyCheck>>"); 
        document.querySelector('[data-toast-notify] [data-toastmsg]').textContent = "Enter the valid number";
        document.querySelector('[data-toast-notify]').classList.add("active");
        return;
      }

      const qty = parseInt(formData.get('quantity')) || 1;
      if(_theme.pincodeValidation.enable && productHandle){
        const result = await _theme.locationValidator.validateVariantLocationQty(productHandle, vid, qty, true);
        if(!result.status) return;
      }

      //setTimeout(function() {refreshCart();},1e3);
      addItemToCart(this);
      //ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });

     $buyItNowBtn.off('click').on('click', async function(evt){
      const _this = this;
      $(this).addClass('is-adding');
      const $form = $(this).closest('form');
      if($form.length === 0) return;
      $(this).find("i").replaceWith('<i class="enj-loader-add-to-cart fsz-unset"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>');

      var formData = new FormData($form[0]);
      const vid = formData.get('id');
      const qty = parseInt(formData.get('quantity')) || 1;

      if(_theme.pincodeValidation.enable) {
        const result = await _theme.locationValidator.validateVariantLocationQty(vid, qty, true);
        if(!result.status) {
          $(this).removeClass('is-adding').find('i').html('');
          return;
        }
      }
      
      window.location.href = `/cart/${vid}:${qty}`;
      $(this).removeClass('is-adding').find('i').html('');

      // ShopifyAPI.addItemFromForm($form[0], async (product, form) => {
      //   $(_this).removeClass('is-adding').find('i').html('');
      //   itemAddedCallback(product, form);
      //   await jQuery.getJSON('/cart.js', function (cart, textStatus) {
      //     localStorage.setItem("cartdata", JSON.stringify(cart));
      //     listcartitems(cart);
      //     beginCheckout(cart);
      //   });
      //   window.location.href = '/checkout';
      // }, itemErrorCallback);

    });
  };

  itemAddedCallback = function (product, form) {
    var $addToCart_btn = $(form).find(settings.addToCartSelector);
    $addToCart_btn.removeClass('is-adding').addClass('is-added');
    $addToCart_btn.find('.enj-loader-add-to-cart').html('<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" height="400" width="400" xml:space="preserve" id="svg2" version="1.1"><metadata id="metadata8"><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/></cc:Work></rdf:RDF></metadata><defs id="defs6"/><g transform="matrix(1.3333333,0,0,-1.3333333,0,400)" id="g10"><g transform="scale(0.1)" id="g12"><path id="path14" style="/* fill:#231f20; */fill-opacity:1;fill-rule:nonzero;stroke:none;" d="M 2539.18,1385.02 C 2479.15,849.23 2004.9,434.289 1446.39,470.129 931.406,503.16 516.711,917.871 483.672,1432.85 c -38.359,597.88 439.844,1099.19 1029.878,1099.19 78.39,0 149.09,-7.24 218.27,-21.98 42.37,-9.03 86.4,4.1 116.99,34.78 v 0 c 71.82,72.04 34.9,194.92 -64.67,215.74 -88.86,18.58 -179.73,29.87 -270.59,29.87 -709.417,0 -1290.445,-581.02 -1290.445,-1290.45 0,-709.418 581.028,-1290.449 1290.445,-1290.449 661.24,0 1210.92,504.781 1282.54,1147.799 8.47,76.02 -50.73,142.65 -127.21,142.65 h -2.45 c -65.64,0 -119.94,-49.75 -127.25,-114.98 z M 894.004,1654.48 v 0 c -49.668,-49.89 -49.578,-130.58 0.207,-180.36 L 1384.35,983.98 2584.51,2184.15 c 49.87,49.87 49.87,130.71 0,180.57 l -0.23,0.23 c -49.88,49.87 -130.74,49.85 -180.6,-0.03 L 1384.35,1344.99 1074.79,1654.67 c -49.94,49.95 -130.95,49.87 -180.786,-0.19"/></g></g></svg>');
    
    $('.product-popup').find('.product-name').html(product.title);  
    $('.product-popup').find('.product-price').html(Shopify.formatMoney(product.price, settings.moneyFormat)); 
    $('.product-popup').find('.product-qty').html(product.quantity,); 
    $('.product-popup').find('.product-total').html(Shopify.formatMoney(product.line_price, settings.moneyFormat)); 
    
	
    $('.product-popup').find('.product-image img').attr('src', product.image);

    showPopup('.product-popup');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    $buyItNowBtn.removeClass('is-adding').find('i').html('');
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    $addToCart.find('.enj-loader-add-to-cart').remove();

    if (!!data.message) {
      if (data.status == 422) {
        let qtyy = $(`select[name="id"] [value="${window.currentVariant_id}"]`).attr('variant-qnty');
        //console.log(">>>>qtyy", qtyy);
        $('.qty-error.limited-stock').hide();
        if($('.qty-error:not(.limited-stock)').length == 0)
        $formContainer.after('<div class="errors qty-error">We have only '+ qtyy + ' units for this product are available. You can order only ' + qtyy + ' units for now.</div>');
        // $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p>' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
      $('.js-number-cart').removeClass('active');
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat)
    }
    $('.product-popup').find('.product-total-cart').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));

    $cartContainer.append(template(data));

    cartCallback(cart);
    $('.js-number-cart').addClass('active');
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    
    $body.on('click', '.remove-product', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = 0
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    })

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id'),
            variantId = $el.attr('data-vid'),
            productHandle = $el.data('product-handle');
        var form = $el.closest('form');
        if(form) var variantId = form.find('[name="id"]').val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id')? $el.data('id') : variantId,
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId,
              variantId: variantId,
              productHandle: productHandle
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', async function() {
        if(_theme.pincodeValidation.enable) _theme.locationValidator.showLoading();
        
        const minQtyJson = JSON.parse(document.querySelector('script[data-min-qty-json]')?.textContent?.trim() || '{}');
        const isPDPPage = $(this).closest('#AddToCartForm') ? true : false;

        const $parent = $(this).closest('.cart_item');
        const validateMinQty = $parent.attr('data-validate-min-qty') ? JSON.parse($parent.attr('data-validate-min-qty')) : false;

        const isCartPage = document.querySelector('body.cart');
        const $el = $(this);
        const $qtySelector = $el.siblings('.js-qty__num');
        let qty = parseInt($qtySelector.val().replace(/\D/g, ''));
        const productHandle = $el.closest('[data-product-handle]').data('product-handle');
        let id = $el.data('id');
        const $atcForm = $el.closest('form[action="/cart/add"]');
        if($atcForm.length){
          id =  $atcForm.find('[name="id"]').val()
        } 

        qty = validateQty(qty);
        const currentQty = qty;
        const isActionTypePlus = $el.hasClass('js-qty__adjust--plus');
        const maxQty = Number($qtySelector.attr('max'));

        if(isPDPPage && !isActionTypePlus && currentQty === 1) {
          return;
        }

        if(isActionTypePlus && maxQty) {
          const nextQty = qty + 1;
          if(nextQty > maxQty) return;
        }

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
          // console.log(id, "Product_qty>>>", qty);
          if(_theme.pincodeValidation.enable && productHandle && id){
            const result = await _theme.locationValidator.validateVariantLocationQty(productHandle, id, qty, true);
            if(!result.status) return;
          }
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        const vid = $qtySelector.attr('data-vid');
        if(_theme.pincodeValidation.enable && isActionTypePlus && isCartPage && productHandle && vid){
          const result = await _theme.locationValidator.validateVariantLocationQty(productHandle, vid, qty, true);
          if(!result.status) return;
        }
        
        // Solar Minimum Quantity :: Start
        if(isActionTypePlus) {
          const {calcQty} = _theme.Helpers.getPDPMinQty(qty, vid);
          qty = calcQty;
        } else {
          if(isPDPPage) {
            const {calcQty, matchedVariant, bundleQty} = _theme.Helpers.getPDPMinQty(qty, _theme.product_json.currentVariant.id);
            if(calcQty !== qty) {
              document.body.classList.add("validating-location-qty");
              const resp = await fetch('/cart.js');
              const cart = await resp.json();
              const totalCartQty = cart.items.filter(lineItem => lineItem.variant_id === Number(vid)).reduce((acc, lineItem) => lineItem.quantity, 0);
              const leftQty = matchedVariant.inventory_quantity - totalCartQty;
              document.body.classList.remove("validating-location-qty");
              if(leftQty >= calcQty) {
                qty = calcQty;
              }
            }
            
            if(currentQty === qty) {
              const errMsg = minQtyJson.pdpErrorMsg.replace('{qty}', currentQty);
              _theme.Helpers.showToastNotification(errMsg);
              return;
            }
          }

          if(isCartPage && validateMinQty) {
            const minQtyJson = JSON.parse(document.querySelector('script[data-min-qty-json]')?.textContent?.trim() || '{}');
            const lineVariantPrice = Number($parent.attr('data-variant-price')) / 100;
            const currentTotalPrice = lineVariantPrice * qty;
            if(currentTotalPrice < minQtyJson.matchPrice) {
              const errMsg = minQtyJson.cartErrorMsg.replace('{qty}', currentQty);
              _theme.Helpers.showToastNotification(errMsg);
              return;
            }
          }
        }
        // Solar Minimum Quantity :: End

        updatePricingQty(qty);

        // Update the input's number
        $qtySelector.val(qty);
        // Submit cart form to update the quantity
        if(_theme.pincodeValidation.enable) _theme.locationValidator.hideLoading();
        if(isCartPage) $('#cart-form').submit();
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));